module.exports = __webpack_public_path__ + "img/website_logo.19b1d06b.png";